export const TEST_IDS = Object.freeze({
  appContentArea: 'content-area',
  sidePanel: 'sidePanel',
  pageContent: 'pageContent',
  formSubmit: 'form-submit',
  formCancel: 'form-cancel',
  formReset: 'form-reset',
  modalDialog: 'modal-dialog',
  modalDialogTitle: 'draggable-dialog-title',
  modalDialogContent: 'modal-content',
  modalClose: 'modal-close',
  notificationsButton: 'notifications-button',
  notificationsDropdownMenu: 'notifications-dropdown-menu',
  ordersNav: 'orders-nav',
  ordersTable: 'orders-table',
  placeOrderButton: 'place-order-button',
  placeOrderDialog: 'place-order-dialog',
  orderProductRow: 'order-product-row',
  addOrderRowButton: 'add-order-row-button',
  submitOrderButton: 'submit-order-button',
  editOrderButton: 'edit-order-button',
  deleteOrderButton: 'delete-order-button',
  markInvoicedButton: 'mark-invoiced-button',
  markShippedButton: 'mark-shipped-button',
  editOrderDialog: 'edit-order-dialog',
  orderProductSelect: 'order-product-select',
  orderQuantityInput: 'order-quantity-input',
  removeOrderRowButton: 'remove-order-row-button',
  accountButton: 'account-button',
  accountMenu: 'account-menu',
  helpButton: 'help-button',
  helpMenu: 'help-menu',
  editBoundaryHelpBubble: 'edit-boundary-help-bubble',
  elevationProfileHelpBubble: 'elevation-profile-help-bubble',
  commonSidebar: 'common-sidebar',
  adminSidebar: 'admin-sidebar',
  adminOrganizationsNav: 'admin-organizations-nav',
  adminPartnersNav: 'admin-partners-nav',
  adminPartnersTab: 'admin-partners-tab',
  adminResellersTab: 'admin-resellers-tab',
  adminOrganizationRenewalsNav: 'admin-organization-renewals-nav',
  organizationRenewalsHideExpiredCheckbox:
    'organization-renewals-hide-expired-checkbox',
  organizationRenewalsSetPaidBtn: 'organization-renewals-set-paid-btn',
  organizationRenewalsSetNotPaidBtn: 'organization-renewals-set-not-paid-btn',
  adminOrganizationVisitWithWizardBtn:
    'admin-organization-visit-with-wizard-btn',
  adminAgProUsersNav: 'admin-ag-pro-users-nav',
  adminSubscriptionsNav: 'admin-subscriptions-nav',
  adminAccessibleAccountsNav: 'admin-accessible-accounts-nav',
  adminUbjUploadsNav: 'admin-ubj-uploads-nav',
  ubjUploadsStartDateInput: 'ubj-uploads-start-date-input',
  ubjUploadsEndDateInput: 'ubj-uploads-end-date-input',
  ubjUploadsApplyDateFilterButton: 'ubj-uploads-apply-date-filter-button',
  ubjUploadsClearDateFilterButton: 'ubj-uploads-clear-date-filter-button',
  ubjUploadsPrevPageButton: 'ubj-uploads-prev-page-button',
  ubjUploadsNextPageButton: 'ubj-uploads-next-page-button',
  ubjUploadsPageSizeSelect: 'ubj-uploads-page-size-select',
  ubjUploadsDownloadButton: 'ubj-uploads-download-button',
  ubjUploadsDownloadZipButton: 'ubj-uploads-download-zip-button',
  adminTrxUploadsNav: 'admin-trx-uploads-nav',
  adminIntegrationsNav: 'admin-integrations-nav',
  adminBulkExportNav: 'admin-bulk-export-nav',
  cffSidebar: 'cff-sidebar',
  cffClientsNav: 'cff-clients-nav',
  cffFarmsNav: 'cff-farms-nav',
  cffFieldsNav: 'cff-fields-nav',
  fieldExportButton: 'field-export-button',
  cffUploadBoundariesNav: 'cff-upload-boundaries-nav',
  farmSettingsSidebar: 'farm-settings-sidebar',
  farmSettingsHardwareNav: 'farm-settings-hardware-nav',
  farmSettingsCombinesNav: 'farm-settings-combines-nav',
  farmSettingsHeadersNav: 'farm-settings-headers-nav',
  farmSettingsUserAccountsNav: 'farm-settings-user-accounts-nav',
  farmSettingsOperatorsNav: 'farm-settings-operators-nav',
  farmSettingsCropsNav: 'farm-settings-crops-nav',
  farmSettingsCropLegendsNav: 'farm-settings-crop-legends-nav',
  farmSettingsPreferencesNav: 'farm-settings-preferences-nav',
  clients: 'clients',
  farms: 'farms',
  harvestPanel: 'harvest-panel',
  harvestSettings: 'harvest-settings',
  harvestSettingsButton: 'harvest-settings-button',
  harvestToolbar: 'harvest-toolbar',
  pointInspection: 'point-inspection',
  pointInfoPopup: 'point-info-popup',
  swathInspection: 'swath-inspection',
  hoverInspection: 'hover-inspection',
  hoverInfoPopup: 'hover-info-popup',
  hoverInspectionStatus: 'hover-inspection-status',
  swathInfoPopup: 'swath-info-popup',
  elevationProfile: 'elevation-profile',
  fieldHoverPopup: 'field-name-hover',
  setHeader: 'set_header',
  editCropType: 'edit_crop_type',
  changeTotalYield: 'change_ty',
  changeTestWeight: 'change_tw',
  editSensorCalibration: 'edit_sensor_calibration',
  editCropCalibration: 'edit_crop_calibration',
  exportHarvest: 'export_harvest',
  editTimeDelay: 'edit_time_delay',
  timeDelayEquipmentSelect: 'time-delay-equipment-select',
  timeDelayInput: 'time-delay-input',
  refreshHarvest: 'refresh',
  downloadUbj: 'download_ubj',
  downloadUbjDialog: 'download-ubj-dialog',
  downloadUbjCheckboxShp: 'download-ubj-checkbox-shp',
  downloadUbjCheckboxJson: 'download-ubj-checkbox-json',
  downloadUbjCheckboxLogs: 'download-ubj-checkbox-logs',
  downloadUbjConfirmButton: 'download-ubj-confirm-button',
  downloadUbjCancelButton: 'download-ubj-cancel-button',
  downloadHarvestLog: 'download_harvest_log',
  harvestLogDialog: 'harvest-log-dialog',
  harvestLogUnavailable: 'harvest-log-unavailable',
  harvestLogError: 'harvest-log-error',
  harvestLogDownloadButton: 'harvest-log-download-button',
  harvestLogCloseButton: 'harvest-log-close-button',
  changeHarvestYear: 'change_harvest_year',
  createHarvests: 'create_harvests',
  createHarvestRequestDialog: 'create-harvest-request-dialog',
  createHarvestRequestCloseButton: 'create-harvest-request-close-button',
  legendPanel: 'legendPanel',
  legendPanelA: 'legendPanelA',
  legendPanelB: 'legendPanelB',
  layersControlButton: 'layers-control-button',
  layersControlPopover: 'layers-control-popover',
  threeDToggleButton: 'three-d-toggle-button',
  threeDControlPopover: 'three-d-control-popover',
  threeDSurfaceSelector: 'three-d-surface-selector',
  threeDVerticalExaggerationSlider: 'three-d-vertical-exaggeration-slider',
  threeDLoadingIndicator: 'three-d-loading-indicator',
  threeDHelpButton: 'three-d-help-button',
  threeDHelpDialog: 'three-d-help-dialog',
  threeDHelpDialogClose: 'three-d-help-dialog-close',
  threeDHelpPlatformTabs: 'three-d-help-platform-tabs',
  outsideBoundaryPointsToggle: 'outside-boundary-points-toggle',
  outsideBoundaryPointsOpacitySlider: 'outside-boundary-points-opacity-slider',
  markerSelectAllCheckbox: 'marker-select-all-checkbox',
  markerAddButton: 'marker-add-button',
  markerDialog: 'marker-dialog',
  markerDialogDeleteButton: 'marker-dialog-delete-button',
  markerDialogConfirmDelete: 'marker-dialog-confirm-delete',
  markerDialogNoteInput: 'marker-dialog-note-input',
  createMarkerDialog: 'create-marker-dialog',
  createMarkerTypeSelect: 'create-marker-type-select',
  createMarkerNoteInput: 'create-marker-note-input',
  userManagementTable: 'user-management-table',
  addUserButton: 'add-user-button',
  editUserButton: 'edit-user-button',
  deleteUserButton: 'delete-user-button',
  userNameInput: 'user-name-input',
  userEmailInput: 'user-email-input',
  userRoleSelect: 'user-role-select',
  userDialog: 'user-dialog',
  userRoleChangeWarning: 'user-role-change-warning',
  deleteUserDialog: 'delete-user-dialog',
  updateBoundariesCheckbox: 'update-boundaries-checkbox',
  fieldReportStartDateInput: 'field-report-start-date-input',
  resellerDiscountInput: 'reseller-discount-input',
  resellerEnabledToggle: 'reseller-enabled-toggle',
  createResellerButton: 'create-reseller-button',
  createResellerDialog: 'create-reseller-dialog',
  createResellerTenantSelect: 'create-reseller-tenant-select',
  createResellerAddButton: 'create-reseller-add-button',
  adminTrxStreamNav: 'trx-stream-page',
  downloadTrxStreamButton: 'download-selected-streams',
  downloadTrxStreamZipButton: 'download-trx-stream-zip-button',
  copyTrxStreamButton: 'copy-selected-streams',
  trxStreamTypeSelect: 'trx-stream-type-select',
  trxStreamSerialNumberInput: 'trx-stream-serial-number-input',
  trxStreamInstanceIdInput: 'trx-stream-instance-id-input',
  trxStreamRecordNumberInput: 'trx-stream-record-number-input',
  trxStreamUploadFromInput: 'trx-stream-upload-from-input',
  trxStreamUploadToInput: 'trx-stream-upload-to-input',
  trxStreamStartFromInput: 'trx-stream-start-from-input',
  trxStreamStartToInput: 'trx-stream-start-to-input',
  trxStreamCopyRowS3KeyButton: 'trx-stream-copy-row-s3-key-button',
  trxStreamFarmSelect: 'trx-stream-farm-select',
  trxStreamFieldSelect: 'trx-stream-field-select',
  trxStreamHarvestSelect: 'trx-stream-harvest-select',
  trxStreamClearFiltersButton: 'trx-stream-clear-filters-button',
  trxLogLevelSelect: 'trx-log-level-select',
  trxLogTagSelect: 'trx-log-tag-select',
  trxLogMessageInput: 'trx-log-message-input',
  trxLogContentLine: 'trx-log-content-line',
  trxLogCopyLinkButton: 'trx-log-copy-link-button',
  trxLogOpenButton: 'trx-log-open-button',
  hardwareViewLogsButton: 'hardware-view-logs-button',
  trxStreamViewLogsButton: 'trx-stream-view-logs-button',
  trxStreamTable: 'trx-stream-table',
  trxStreamSelectAllCheckbox: 'trx-stream-select-all-checkbox',
  trxStreamRowCheckbox: 'trx-stream-row-checkbox',
  trxStreamPagination: 'trx-stream-pagination',
  generateCropLegendsButton: 'generate-crop-legends-button',
  generateCropLegendsDialog: 'generate-crop-legends-dialog',
  generateCropLegendsYearSelect: 'generate-crop-legends-year-select',
  generateCropLegendsParameterSelect: 'generate-crop-legends-parameter-select',
  generateCropLegendsRangeSelect: 'generate-crop-legends-range-select',
  generateCropLegendsLowPercentileInput:
    'generate-crop-legends-low-percentile-input',
  generateCropLegendsHighPercentileInput:
    'generate-crop-legends-high-percentile-input',
  generateCropLegendsRunButton: 'generate-crop-legends-run-button',
  generateCropLegendsApplyButton: 'generate-crop-legends-apply-button',
  generateCropLegendsApplyAllButton: 'generate-crop-legends-apply-all-button',
  generateCropLegendsCancelButton: 'generate-crop-legends-cancel-button',
  generateCropLegendsError: 'generate-crop-legends-error',
  cropLegendDeleteButton: 'crop-legend-delete-button',
  deleteCropLegendDialog: 'delete-crop-legend-dialog',
  deleteCropLegendConfirmButton: 'delete-crop-legend-confirm-button',
  deleteCropLegendError: 'delete-crop-legend-error',
  generateDemLegendButton: 'generate-dem-legend-button',
  cropLegendYearFilter: 'crop-legend-year-filter',
  emailValidationComponent: 'email-validation-component',
  emailValidationOkButton: 'email-validation-ok-button',
  emailValidationLogoutButton: 'email-validation-logout-button',
  headersTable: 'headers-table',
  addHeaderButton: 'add-header-button',
  headerDeleteDisabledAlert: 'header-delete-disabled-alert',
  headerSaveButton: 'header-save-button',
  headerCancelButton: 'header-cancel-button',
  headerEditButton: 'header-edit-button',
  headerDeleteButton: 'header-delete-button',
  headerNameInput: 'header-name-input',
  headerTypeSelect: 'header-type-select',
  headerNumRowsInput: 'header-num-rows-input',
  headerRowSpacingInput: 'header-row-spacing-input',
  headerRowSpacingSelect: 'header-row-spacing-select',
  headerCutWidthInput: 'header-cut-width-input',
  headerWidthFtInput: 'header-width-ft-input',
  headerWidthInInput: 'header-width-in-input',
  headerUnitsSelect: 'header-units-select',
  equipmentTable: 'equipment-table',
  addEquipmentButton: 'add-equipment-button',
  equipmentDeleteDisabledAlert: 'equipment-delete-disabled-alert',
  equipmentDuplicateNameAlert: 'equipment-duplicate-name-alert',
  equipmentSaveButton: 'equipment-save-button',
  equipmentCancelButton: 'equipment-cancel-button',
  equipmentEditButton: 'equipment-edit-button',
  equipmentDeleteButton: 'equipment-delete-button',
  equipmentNicknameInput: 'equipment-nickname-input',
  equipmentMakeSelect: 'equipment-make-select',
  equipmentModelSelect: 'equipment-model-select',
  equipmentYearInput: 'equipment-year-input',
  equipmentTimeDelayInput: 'equipment-time-delay-input',
  changeEmailButton: 'change-email-button',
  changeEmailDialog: 'change-email-dialog',
  changeEmailNewEmailInput: 'change-email-new-email-input',
  changeEmailConfirmInput: 'change-email-confirm-input',
  changeEmailSubmitButton: 'change-email-submit-button',
  changeEmailCancelButton: 'change-email-cancel-button',
  changeEmailPendingBanner: 'change-email-pending-banner',
  changeEmailResendButton: 'change-email-resend-button',
  changeEmailCancelPendingButton: 'change-email-cancel-pending-button',
  userDetailsCloseButton: 'user-details-close-button',
  userPreferencesCloseButton: 'user-preferences-close-button',
  modalCloseButton: 'modal-close-button',
  cffAlertCloseButton: 'cff-alert-close-button',
})

export function getFieldTestId(name: string): string {
  return `field-${name}`
}

export function getFormTestId(id: string): string {
  return `js-form-${id}`
}
